import { useStyles } from '../../style';

const TitleCellHeader = ({ text }) => {
  const classes = useStyles({});

  return <div className={classes.titleCellHeader}>{text}</div>;
};

export default TitleCellHeader;
